moduleViewApp.service("HeaderRowCompatibilityService", ['$rootScope', 'DebugHelper', ($rootScope, DebugHelper) ->
  $scope = $rootScope.$new()

  DebugHelper.register("HeaderRowCompatibilityService", $scope)

  _.assignIn $scope,
    repeatableHeadingCompatibilityMap:
      "cue_distractor_(\\\d)_text": "anchor_distractor_text_html"
      "cue_distractor_(\\\d)_text_html": "anchor_distractor_text_html"
      "cue_distractor_(\\\d)_image": "anchor_distractor_image"
      "anchor_distractor_(\\\d)_text": "anchor_distractor_text_html"
      "anchor_distractor_(\\\d)_text_html": "anchor_distractor_text_html"
      "anchor_distractor_(\\\d)_image": "anchor_distractor_image"
      "association_(\\\d)_text": "association_text_html"
      "association_(\\\d)_text_html": "association_text_html"
      "association_(\\\d)_image": "association_image"
      "association_(\\\d)_sound": "association_sound"
      "association_(\\\d)_label": "association_label"
      "association_(\\\d)_language": "association_language"
      "association_(\\\d)_question": "association_question"
      "association_(\\\d)_random_distractors": "association_random_distractors"
      "association_(\\\d)_distractor_(\\\d)_text": "association_distractor_text_html"
      "association_(\\\d)_distractor_(\\\d)_text_html": "association_distractor_text_html"
      "association_(\\\d)_distractor_(\\\d)_image": "association_distractor_image"
      "sentence_(\\\d)_text": "sentence_text_html"
      "sentence_(\\\d)_text_html": "sentence_text_html"
      "sentence_(\\\d)_transliteration": "sentence_transliteration_html"
      "sentence_(\\\d)_transliteration_html": "sentence_transliteration_html"
      "sentence_(\\\d)_translation": "sentence_translation_html"
      "sentence_(\\\d)_translation_html": "sentence_translation_html"
      "sentence_(\\\d)_image": "sentence_image"
      "sentence_(\\\d)_sound": "sentence_sound"
      "association_(\\\d)_direction": "association_direction"

    columnHeadingCompatibilityMap:
      item_type: "item_type"
      cue_text: "anchor_text_html"
      cue_image: "anchor_image"
      cue_sound: "anchor_sound"
      anchor_text: "anchor_text_html"
      anchor_text_html: "anchor_text_html"
      anchor_image: "anchor_image"
      anchor_sound: "anchor_sound"
      cue_transliteration: "anchor_transliteration_html"
      anchor_transliteration: "anchor_transliteration_html"
      anchor_transliteration_html: "anchor_transliteration_html"
      cue_character: "ignored"
      cue_part_of_speech: "anchor_part_of_speech"
      direction: ["association_direction", 0]
      annotation_text: "notes_text_html"
      annotation_image: "notes_image"
      annotation_sound: "notes_sound"
      notes_text: "notes_text_html"
      notes_text_html: "notes_text_html"
      notes_image: "notes_image"
      notes_sound: "notes_sound"
      notes_embed: "notes_external_resource_url"
      cue_question: "anchor_question_html"
      anchor_question: "anchor_question_html"
      anchor_question_html: "anchor_question_html"
      language_pair_id: "legacy_language_pair_id"
      anchor_random_distractors: "anchor_random_distractors"

    anchorHeadings: [
      "anchor_text_html"
      "anchor_image"
      "anchor_sound"
    ]

    associationHeadings: [
      "association_text_html"
      "association_image"
      "association_sound"
    ]

    normalizeRepeatableHeading: (heading) ->
      for pair in _.toPairs($scope.repeatableHeadingCompatibilityMap)
        pattern = pair[0]
        normalizedPattern = pair[1]
        re = new RegExp("\^" + pattern + "\$")
        match = heading.match(re)
        if match
          # subtract 1 since we're going from 1 indexed to 0 indexed
          if match[2]
            return [normalizedPattern, match[2] - 1, match[1] - 1]
          else
            return [normalizedPattern, match[1] - 1]
        else
          continue
      false

    # Takes in V1 or V2 heading and spits out a valid heading and index for the Field Mapper or false
    normalizeHeading: (heading) ->
      heading = heading.replace(/response/, "association").replace(/association_(?=[a-zA-Z])/, "association_1_")
      $scope.columnHeadingCompatibilityMap[heading] || $scope.normalizeRepeatableHeading(heading)

    hasRequiredHeadings: (headings) ->
      _.intersection(headings, $scope.anchorHeadings).length > 0 && _.intersection(headings, $scope.associationHeadings).length > 0

  $scope
])
